/**
 * Progress handler to show various states of progress for operations taking place
 */
let PageErrors = {
    /**
     * The ID of the div that will handle this progress and such
     *
     * @type string
     */
    ID: '#flash-notices',

    /**
     * How long to set the next message to run in seconds
     *
     * @type int
     */
    Length: 8,

    /**
     * The timeout that is used for setTimeout and clearTimeout
     *
     * @type number
     */
    Timeout: null,

    /**
     * Hide our progress indicator
     *
     * @return void
     */
    Hide: function() {
        // Hide it
        $(this.ID).slideUp('fast', function() {
            $(PageErrors.ID).html('');
            $(window).resize();
        });
    },

    /**
     * Resets the timeout on the hide for the progress indicator and shows a new message
     *
     * @return void
     */
    Show: function() {
        // Show the progress indicator
        $(this.ID).slideDown('fast', function() {
            $(window).resize();
        });

        // Remove the current timeout
        if (this.Timeout !== null) {
            clearTimeout(this.Timeout);
        }

        // Set new one
        this.Timeout = setTimeout(function() {
            PageErrors.Hide();
        }, this.Length * 1000);
    },

    /**
     * Show a warning message
     *
     * @param text string
     */
    Warning: function(text) {
        // Add a message
        $(this.ID).append(
            '<div class="alert alert-warning alert-dismissible" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                text +
            '</div>'
        );

        // Show it
        this.Show();
    },

    /**
     * Show a success message
     *
     * @param text string
     */
    Success: function(text) {
        // Add a message
        $(this.ID).append(
            '<div class="alert alert-success alert-dismissible" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                text +
            '</div>'
        );

        // Show it
        this.Show();
    },

    /**
     * Show an error message
     *
     * @param {string} text
     * @param {object} selector
     */
    Error: function(text, selector) {
        // Add a message
        $(selector !== undefined ? selector : this.ID).append(
            '<div class="alert alert-danger alert-dismissible" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
                text +
            '</div>'
        );

        // Show it
        if (selector === undefined) {
            this.Show();
        }
    },
};

// Export the module
module.exports = PageErrors;
